import { createAction, createAsyncThunk } from "@reduxjs/toolkit";
import type { Dependencies } from "@redux/store";

export const sendUserInvitation = createAsyncThunk<void, string, { extra: Partial<Dependencies> }>(
  "users/sendUserInvitation",
  async (userId: string, { extra: { adminRepository } }) => {
    return adminRepository!.sendUserInvitation(userId);
  },
);

export const resetSendUserInvitation = createAction("users/resetSendUserInvitation");
